import React, { Component, ComponentType } from 'react';
import { wrapDisplayName } from 'recompose';
import { Subtract } from 'utils/rxs';
import { flux } from '../singletons';
import { FluxType } from 'flux/buildFlux';
import { AddFluxHOCProps } from 'components/wrappers/WithFlux';

interface FluxxorConnectInternalState<T> {
  mappedState: T;
}

function fluxxorConnect<Outer, Inner>(storeNames: string[], mapStateToProps: (flux: FluxType, p: Outer) => Outer) {
  return function (ComposedComponent: ComponentType<Outer & AddFluxHOCProps>): ComponentType<Subtract<Inner, Outer & AddFluxHOCProps>> {
    return class FluxxorConnectInternal extends Component<Inner & AddFluxHOCProps & Outer> {
      static displayName = wrapDisplayName(ComposedComponent, 'fluxxorConnect');

      state: FluxxorConnectInternalState<Outer> = {
        mappedState: null,
      };

      setStateFromFlux = () => {
        const mappedState: Outer = mapStateToProps.call(this, flux, this.props);
        this.setState({ mappedState });
      };

      componentDidMount() {
        storeNames.forEach((store) => {
          flux.store(store).on('change', this.setStateFromFlux);
        });

        this.setStateFromFlux();
      }

      componentWillUnmount() {
        storeNames.forEach((store) => {
          flux.store(store).removeListener('change', this.setStateFromFlux);
        });
      }

      render() {
        if (this.state.mappedState) {
          const props = Object.assign({ flux }, this.props);

          return <ComposedComponent {...props} {...this.state.mappedState} />;
        }

        return null;
      }
    };
  };
}

export default fluxxorConnect;
